import { Link } from 'react-router-dom';

interface FeaturedComicProps {
  id: number;
  title: string;
  slug: string;
  cover: string;
  description: string;
  author: string;
  status: string;
  latestChapter: string;
  rating: number;
  ratingCount: number;
}

export default function FeaturedComic({
  id,
  title,
  slug,
  cover,
  description,
  author,
  status,
  latestChapter,
  rating,
  ratingCount,
}: FeaturedComicProps) {
  return (
    <div className="relative rounded-lg overflow-hidden group cursor-pointer h-[420px] md:h-[500px]">
      <img
        src={cover}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        title={`${title} - 虫虫动漫免费漫画`}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/30 to-black/80"></div>
      <Link to={`/article/${id}/${slug}`} className="absolute inset-0 z-10">
        <span className="sr-only">{title}</span>
      </Link>
      <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 z-20">
        <div className="flex items-center gap-2 mb-2">
          <span className={`px-2 py-0.5 text-xs rounded-full ${
            status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
          <span className="text-xs text-background-50/80">{author}</span>
        </div>
        <h2 className="text-xl md:text-3xl font-heading text-background-50 mb-2">
          {title}
        </h2>
        <p className="text-sm text-background-50/80 line-clamp-2 mb-3 max-w-lg">
          {description}
        </p>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-400"></i>
            <span className="text-sm text-background-50 font-medium">{rating}</span>
            <span className="text-xs text-background-50/60">({(ratingCount / 10000).toFixed(1)}万评)</span>
          </div>
          <span className="text-xs text-background-50/70">{latestChapter}</span>
        </div>
      </div>
    </div>
  );
}